import { Component, Inject, OnDestroy } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';
import { MatFormField, MatInput } from '@angular/material/input';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatLabel } from '@angular/material/form-field';
import { catchError, NEVER, Subscription, tap } from 'rxjs';
import { UtilsTableService } from '../../services/utils-table.service';
import { Tab } from '../../models/utils-tabs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatIcon } from '@angular/material/icon';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

interface DialogData {
  tab: Tab;
}

@Component({
  selector: 'app-share-view',
  standalone: true,
  templateUrl: './share-view.component.html',
  imports: [
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatButton,
    MatDialogClose,
    MatFormField,
    MatInput,
    ReactiveFormsModule,
    MatLabel,
    MatIcon,
    MatProgressSpinner
  ],
  styleUrl: './share-view.component.scss'
})
export class ShareViewComponent implements OnDestroy {
  emailControl = new FormControl(null);
  validated = false;
  userFound = false;
  tabExists = false;
  sharing = false;
  validating = false;

  private subscription = new Subscription();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private matDialogRef: MatDialogRef<ShareViewComponent>,
    private utilsTableService: UtilsTableService,
    private matSnackBar: MatSnackBar
  ) {}

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  validate() {
    if (this.emailControl.value) {
      this.validating = true;
      this.subscription.add(
        this.utilsTableService
          .validateView(this.emailControl.value, this.data.tab.id)
          .pipe(
            tap(({ tabExists, userFound }) => {
              this.validating = false;
              this.userFound = userFound;
              this.tabExists = tabExists;
              this.validated = true;
            }),
            catchError(error => {
              this.validating = false;
              this.validated = true;
              console.error(error);
              this.matSnackBar.open('Could not validate the view. Please try again later.', 'x');
              return NEVER;
            })
          )
          .subscribe()
      );
    }
  }

  share() {
    if (this.emailControl.value) {
      this.sharing = true;
      this.subscription.add(
        this.utilsTableService
          .shareView(this.emailControl.value, this.data.tab.id)
          .pipe(
            tap(() => {
              this.sharing = false;
              this.matSnackBar.open('The view has been shared successfully', 'x', { panelClass: 'snackbar-green' });
              this.matDialogRef.close();
            }),
            catchError(error => {
              this.sharing = false;
              console.error(error);
              this.matSnackBar.open('Could not share the view. Please try again later.', 'x');
              return NEVER;
            })
          )
          .subscribe()
      );
    }
  }
}
